import { ComponentConfig } from "@measured/puck";
import { HeaderContactOptions } from "@kunduz/ui-components";
import Head from "next/head";
import { NextSeo } from "next-seo";
import {
  DynamicHeader,
  HeaderBannerWithContext,
  WebsiteEnFooter,
  WebsiteTrFooter,
} from "@kunduz/feature-landing-pages";
import { IContent } from "@kunduz/data-access-cms-api";
import classNames from "classnames";
import styles from "./root.module.scss";
import { headerItems } from "./utils";

export interface RootProps {
  meta?: {
    seo_title?: string;
    seo_desc?: string;
    canonical_url?: string;
    no_index?: boolean;
    seo_icon?: string;
    header_items?: IContent.HeaderItemsResponsePuck;
    landing_page_header?: "student" | "teacher" | "school";
    language?: "tr" | "en";
    slug?: string;
    name?: string;
    content_type?: string;
  };
  headerBannerData?: {
    name: string;
    data: IContent.HeaderBannerComponentData;
  };
  live: boolean;
}

export const Root: ComponentConfig<RootProps> = {
  fields: {
    live: {
      label: "Live",
      type: "radio",
      options: [
        { label: "Enabled", value: true },
        { label: "Disabled", value: false },
      ],
    },
    meta: {
      type: "object",
      objectFields: {
        canonical_url: {
          type: "text",
          label: "Canonical URL",
        },
        seo_title: {
          type: "text",
          label: "SEO Title",
        },
        seo_desc: {
          type: "text",
          label: "SEO Description",
        },
        no_index: {
          type: "radio",
          label: "No Index",
          options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
          ],
        },
        seo_icon: {
          type: "text",
          label: "SEO Icon",
        },
        landing_page_header: {
          type: "radio",
          label: "Landing Page Header",
          options: [
            { label: "Student", value: "student" },
            { label: "Teacher", value: "teacher" },
            { label: "School", value: "school" },
          ],
        },
        header_items: {
          type: "select",
          label: "Header Items",
          options: [
            { label: "TR - Ogrenci", value: "tr_student" },
            { label: "TR - Okul", value: "tr_school" },
            { label: "E - Ogrenci", value: "e_student" },
            { label: "TR - Egitmen", value: "tr_teacher" },
          ],
        },
        // header_items: {
        //   type: "object",
        //   label: "Header Items",
        //   objectFields: {
        //     name: {
        //       type: "text",
        //       label: "Name",
        //     },
        //     language: {
        //       type: "radio",
        //       label: "Language",
        //       options: [
        //         { label: "Turkish", value: "tr" },
        //         { label: "English", value: "en" },
        //       ],
        //     },
        //     profile: {
        //       type: "text",
        //       label: "Profile",
        //     },
        //     components: {
        //       type: "array",
        //       label: "Components",
        //       arrayFields: {
        //         type: {
        //           type: "select",
        //           label: "Type",
        //           options: [
        //             {
        //               label: "Header Menu Component",
        //               value: "headermenucomponent",
        //             },
        //             {
        //               label: "Header Button Component",
        //               value: "headerbuttoncomponent",
        //             },
        //             {
        //               label: "Header Image Component",
        //               value: "headerimagecomponent",
        //             },
        //           ],
        //         },
        //         data: {
        //           type: "object",
        //           label: "Data",
        //           objectFields: {
        //             type: {
        //               type: "select",
        //               label: "Type",
        //               options: [
        //                 { label: "Gradient", value: "gradient" },
        //                 { label: "Primary", value: "primary" },
        //                 { label: "Secondary", value: "secondary" },
        //                 { label: "Tertiary", value: "tertiary" },
        //                 { label: "Link", value: "link" },
        //               ],
        //             },
        //             name: {
        //               type: "text",
        //               label: "Name",
        //             },
        //             image: {
        //               type: "text",
        //               label: "Image URL",
        //             },
        //             alt_text: {
        //               type: "text",
        //               label: "Alt Text",
        //             },
        //             desktop_position: {
        //               type: "select",
        //               label: "Desktop Position",
        //               options: [
        //                 { label: "Left", value: "left" },
        //                 { label: "Right", value: "right" },
        //               ],
        //             },
        //             mobile_position: {
        //               type: "select",
        //               label: "Mobile Position",
        //               options: [
        //                 { label: "Top", value: "top" },
        //                 { label: "Bottom", value: "bottom" },
        //                 { label: "Left", value: "left" },
        //                 { label: "Right", value: "right" },
        //               ],
        //             },
        //             hide_for_authenticated_user: {
        //               type: "radio",
        //               label: "Hide for Authenticated User",
        //               options: [
        //                 { label: "Yes", value: true },
        //                 { label: "No", value: false },
        //               ],
        //             },
        //             hide_for_unauthenticated_user: {
        //               type: "radio",
        //               label: "Hide for Unauthenticated User",
        //               options: [
        //                 { label: "Yes", value: true },
        //                 { label: "No", value: false },
        //               ],
        //             },
        //             label: {
        //               type: "text",
        //               label: "Label",
        //             },
        //             url: {
        //               type: "text",
        //               label: "URL",
        //             },
        //             icon: {
        //               type: "text",
        //               label: "Icon URL",
        //             },
        //             title: {
        //               type: "text",
        //               label: "Title",
        //             },
        //             description: {
        //               type: "textarea",
        //               label: "Description",
        //             },
        //             target: {
        //               type: "select",
        //               label: "Target",
        //               options: [
        //                 { label: "_blank", value: "_blank" },
        //                 { label: "_self", value: "_self" },
        //               ],
        //             },
        //             childs: {
        //               type: "array",
        //               label: "Child Items",
        //               arrayFields: {
        //                 title: {
        //                   type: "text",
        //                   label: "Child Title",
        //                 },
        //                 type: {
        //                   type: "text",
        //                   label: "Child Type",
        //                 },
        //                 url: {
        //                   type: "text",
        //                   label: "Child URL",
        //                 },
        //                 icon: {
        //                   type: "text",
        //                   label: "Child Icon",
        //                 },
        //                 description: {
        //                   type: "textarea",
        //                   label: "Child Description",
        //                 },
        //                 badge_text: {
        //                   type: "text",
        //                   label: "Badge Text",
        //                 },
        //                 badge_type: {
        //                   type: "text",
        //                   label: "Badge Type",
        //                 },
        //                 childs: {
        //                   type: "array",
        //                   label: "Nested Child Items",
        //                   arrayFields: {
        //                     title: {
        //                       type: "text",
        //                       label: "Nested Child Title",
        //                     },
        //                     type: {
        //                       type: "text",
        //                       label: "Nested Child Type",
        //                     },
        //                     url: {
        //                       type: "text",
        //                       label: "Nested Child URL",
        //                     },
        //                     icon: {
        //                       type: "text",
        //                       label: "Nested Child Icon",
        //                     },
        //                     description: {
        //                       type: "textarea",
        //                       label: "Nested Child Description",
        //                     },
        //                   },
        //                 },
        //                 desktop_position: {
        //                   type: "select",
        //                   label: "Desktop Position",
        //                   options: [
        //                     { label: "Left", value: "left" },
        //                     { label: "Right", value: "right" },
        //                   ],
        //                 },
        //                 mobile_position: {
        //                   type: "select",
        //                   label: "Mobile Position",
        //                   options: [
        //                     { label: "Top", value: "top" },
        //                     { label: "Bottom", value: "bottom" },
        //                     { label: "Left", value: "left" },
        //                     { label: "Right", value: "right" },
        //                   ],
        //                 },
        //                 is_for_authenticated_user: {
        //                   type: "radio",
        //                   label: "Is for Authenticated User",
        //                   options: [
        //                     { label: "Yes", value: true },
        //                     { label: "No", value: false },
        //                   ],
        //                 },
        //               },
        //             },
        //             badge_text: {
        //               type: "text",
        //               label: "Badge Text",
        //             },
        //             badge_type: {
        //               type: "text",
        //               label: "Badge Type",
        //             },
        //           },
        //         },
        //       },
        //       defaultItemProps: {
        //         type: "headermenucomponent",
        //         data: {
        //           type: "primary",
        //           name: "Menu Item 1",
        //           image: "https://example.com/image1.png",
        //           alt_text: "Menu Item 1 Alt Text",
        //           desktop_position: "left",
        //           mobile_position: "top",
        //           hide_for_authenticated_user: false,
        //           hide_for_unauthenticated_user: false,
        //           label: "Menu 1",
        //           url: "/menu-1",
        //           icon: "https://example.com/icon1.png",
        //           title: "Menu Item 1 Title",
        //           description: "Description for Menu Item 1",
        //           target: "_self",
        //           childs: [
        //             {
        //               title: "Child Item 1",
        //               type: "link",
        //               url: "/child-1",
        //               icon: "https://example.com/child-icon1.png",
        //               description: "Child Item 1 Description",
        //               badge_text: "New",
        //               badge_type: "info",
        //               childs: [],
        //               desktop_position: "left",
        //               mobile_position: "top",
        //               is_for_authenticated_user: true,
        //             },
        //           ],
        //           badge_text: "Hot",
        //           badge_type: "warning",
        //         },
        //       },
        //     },
        //   },
        // },
        slug: {
          type: "text",
          label: "Slug",
        },
        name: {
          type: "text",
          label: "Name",
        },
        content_type: {
          type: "text",
          label: "Content Type",
        },
        language: {
          type: "radio",
          label: "Language",
          options: [
            { label: "Turkish", value: "tr" },
            { label: "English", value: "en" },
          ],
        },
      },
    },
    headerBannerData: {
      type: "object",
      label: "Header Banner Data",
      objectFields: {
        name: {
          type: "text",
          label: "Name",
        },
        data: {
          type: "object",
          label: "Data",
          objectFields: {
            cta_title: {
              type: "text",
              label: "CTA Title",
            },
            content: {
              type: "text",
              label: "Content",
            },
            cta_link: {
              type: "text",
              label: "CTA Link",
            },
          },
        },
      },
    },
  },
  defaultProps: {
    live: false,
  },
  render: ({ puck: { renderDropZone: DropZone, isEditing }, ...props }) => {
    const { meta, headerBannerData } = props;

    const header_items = headerItems[meta.header_items];

    return (
      <>
        <Head>
          <link rel="preconnect" href="https://media.kunduz.com" />
        </Head>

        <NextSeo
          title={meta?.seo_title}
          description={meta?.seo_desc}
          canonical={meta?.canonical_url}
          noindex={meta?.no_index}
          openGraph={{
            images: [{ url: meta?.seo_icon as string }],
          }}
        />

        {headerBannerData?.name && headerBannerData?.data && (
          <HeaderBannerWithContext
            name={headerBannerData.name}
            buttonLabel={headerBannerData.data.cta_title}
            label={headerBannerData.data.content}
            url={headerBannerData.data.cta_link}
          />
        )}

        {meta.language == "tr" && (
          <HeaderContactOptions
            secondLabel="0850 532 16 29"
            secondUrl="tel:08505321629"
            thirdLabel="Sıkça Sorulan Sorular"
            thirdUrl="/tr/sss/"
            forthLabel="destek@kunduz.com"
            forthUrl="mailto:destek@kunduz.com"
          />
        )}
        {meta.language == "en" && (
          <HeaderContactOptions
            thirdLabel="Frequently Asked Questions"
            thirdUrl="/faq/"
            forthLabel="school@kunduz.com"
            forthUrl="mailto:school@kunduz.com"
          />
        )}

        <div
          className={classNames("puck-root", { [styles.isEditing]: isEditing })}
        >
          {meta && meta.language && (
            <DynamicHeader
              headerItems={header_items as any}
              headerType={meta.landing_page_header}
              lang={meta.language}
            />
          )}

          <DropZone
            zone="default-zone"
            style={{ flexGrow: 1, minHeight: "100vh" }}
          />

          {meta.language == "tr" && <WebsiteTrFooter />}
          {meta.language == "en" && <WebsiteEnFooter />}
        </div>
      </>
    );
  },
};

export default Root;
